import { TAB_VIEWS } from 'productTemplate/enums/buyBarMobile';
import { getNew, getOffers, getUsed } from 'productTemplate/utils/buyBar/accordionUtils';

export const getActiveVariantData = ({
  buyBarView,
  buyNewVariant = null,
  buyUsedVariant = null,
  isApparelProduct,
  makeOfferVariant = null,
  buyBarSizesMap,
  isOfferable,
  offersMap,
  size = null,
}) => {
  let buyNewPrice = null;
  let buyUsedPrice = null;
  let makeOfferPrice = null;
  let productVariants;
  let selectedSize;

  const newList = getNew(buyBarSizesMap);
  const usedList = getUsed(buyBarSizesMap);

  if (buyBarView === TAB_VIEWS.NEW) {
    productVariants = newList;
    selectedSize = size || buyNewVariant?.sizeOption?.presentation; // get size or initial load size
    buyNewPrice = buyNewVariant?.lowestPriceCents?.amount || null; // buy button price
  } else if (buyBarView === TAB_VIEWS.USED) {
    productVariants = usedList;
    selectedSize = size || buyUsedVariant?.sizeOption?.presentation;
    buyUsedPrice = buyUsedVariant?.lowestPriceCents?.amount || null;
  } else {
    productVariants = isOfferable ? getOffers(offersMap) : [];
    selectedSize = size || makeOfferVariant?.sizeOption?.presentation;
    makeOfferPrice = makeOfferVariant?.topOffer?.amount || null;
  }

  const activeVariant = productVariants.find(
    (availableSizes) => availableSizes[0] === selectedSize,
  );
  const instantShipPrice =
    activeVariant?.[1]?.instantShip?.instantShipLowestPriceCents?.amount || null;
  const lowestNewPrice = instantShipPrice < buyNewPrice ? instantShipPrice : buyNewPrice;
  const priceBySize =
    activeVariant?.[1]?.bestPrice?.lowestPriceCents?.amount ||
    activeVariant?.[1]?.topOffer?.amount || // if no best price, use top offer for offers price
    null;

  // apparel products don't have selected size preferences so if there is ANY stock we want to show true
  const newStock = isApparelProduct
    ? newList.length > 0
    : !!newList.some((variant) => variant[0] === size);
  const usedStock = isApparelProduct
    ? usedList.length > 0
    : !!usedList.some((variant) => variant[0] === size);

  /* if we have the expanded size, we want to use it to get the active variant price but
    on page load we don't have the expanded size so we use the price from the buy button variant */
  const activeVariantPrice = size ? priceBySize : lowestNewPrice || buyUsedPrice || makeOfferPrice;

  return {
    activeVariantPrice,
    productVariants,
    selectedSize,
    activeVariant,
    newStock,
    usedStock,
    instantShipPrice,
    buyNewPrice,
    buyUsedPrice,
    makeOfferPrice,
  };
};
